"use client";

import { caseStudies } from "@/lib/dto/case-studies/case-studies";
import CaseStudyHeroSection from "./_components/CaseStudyHeroSection";
import GridCaseStudyCard from "./_components/GridCaseStudyCard";
import HorizontalCaseStudyCard from "./_components/HorizontalCaseStudyCard";

export default function CaseStudiesPage() {
  const heroCaseStudy = caseStudies[0];
  const chargeawayCaseStudy = caseStudies.find((cs) => cs.id === "cs14");
  const gdrCaseStudy = caseStudies.find((cs) => cs.id === "cs19");

  // Keep ChargeAway only once (horizontal card), while preserving full grid rows.
  // We exclude: hero + ChargeAway, then take the next 3 for grid row 1.
  const usedIds = new Set<string>([heroCaseStudy.id]);
  if (chargeawayCaseStudy) usedIds.add(chargeawayCaseStudy.id);

  const gridCaseStudies = caseStudies
    .filter((cs) => !usedIds.has(cs.id))
    .slice(0, 3);

  for (const cs of gridCaseStudies) usedIds.add(cs.id);
  if (gdrCaseStudy) usedIds.add(gdrCaseStudy.id);

  const gridCaseStudies2 = caseStudies.filter((cs) => !usedIds.has(cs.id));

  return (
    <main className="min-h-screen bg-[#F7F8FC]">
      {/* Hero Section */}
      <CaseStudyHeroSection />

      {/* Case Studies Content */}
      <div className="case-studies-content">
        <div className="container mx-auto pt-18 pb-18 px-5 sm:px-10 lg:px-12 xl:px-16 max-w-[105rem]">
          {/* Horizontal Hero Card */}
          <div className="mb-12">
            <HorizontalCaseStudyCard caseStudy={heroCaseStudy} />
          </div>

          {/* Grid Cards Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {gridCaseStudies.map((caseStudy) => (
              <GridCaseStudyCard key={caseStudy.id} caseStudy={caseStudy} />
            ))}
          </div>

          {/* Additional Horizontal Card - ChargeAway */}
          {chargeawayCaseStudy && (
            <div className="mb-12">
              <HorizontalCaseStudyCard caseStudy={chargeawayCaseStudy} />
            </div>
          )}

          {/* Grid Cards Row 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {gridCaseStudies2.map((caseStudy) => (
              <GridCaseStudyCard key={caseStudy.id} caseStudy={caseStudy} />
            ))}
          </div>

          {gdrCaseStudy && (
            <div className="mb-12">
              <HorizontalCaseStudyCard caseStudy={gdrCaseStudy} />
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
